/**
 * Created by Jie Gao on 2019-05-20.
 */
import {DragonTribeParsedGameData} from "../../server/data/DragonTribeParsedGameData";
import {WildSymbolNudgeAnimation} from "./WildSymbolNudgeAnimation";
import {TimelineLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {DragonTribeParsedInitData} from "../../server/data/DragonTribeParsedInitData";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";

export class WildSymbolNudge extends ReelStopPresentationController {

    private _wildOnReel:boolean[];
    private _wildOnReelPos:number[];
    private _multiplierOnReel:number[];
    private _view:WildSymbolNudgeAnimation;
    private _reels:string[][];
    private _timeline:TimelineLite | null;
    protected _winPositions:boolean[][] = [];

    private _isRestore:boolean;
    private _gameAreaSize:number[];

    constructor(index:number) {
        super(index, "WildSymbolNudge");
        this._view = new WildSymbolNudgeAnimation();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, (event:GameEvent) => this.onSpinStopped());
    }

    private onBeforeSpinStart():void {
        if(this._isRestore) {
            this._wildOnReel.forEach((hasWild:boolean, i:number) => {
                if(hasWild) {
                    this._view.showStackWild(i, this._multiplierOnReel[i], this._gameAreaSize[i]);
                }
            });
            this._isRestore = false;
        }
        this._view.resetMultipliers();
    }

    private onSpinStopped():void {
        this._view.resetAnimations();
    }

    protected onInitGameDataParsed(data:DragonTribeParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._wildOnReel = data.wildsOnReel;
        this._gameAreaSize = data.gameAreaSize;
        this._multiplierOnReel = data.wildMultipliers;
    }

    protected parseFeatureGameData(data:DragonTribeParsedGameData):void {
        this._winPositions = data.allWinPositions;
        this._wildOnReel = [];
        this._wildOnReelPos = [];
        this._multiplierOnReel = data.wildMultipliers;
        this._reels = ((data.newSymbols.length > 0) ? data.newSymbols : data.reels);
        this._reels.forEach((reel:string[], i:number) => {
            let hasWild:boolean = reel.indexOf("W") > -1;
            this._wildOnReelPos.push((hasWild ? (6 - data.wildMultipliers[i]) : -1));
            this._wildOnReel.push(hasWild);
        });
        this._gameAreaSize = data.actualReelSize;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(data.reelId !== 5 || (this._wildOnReel.indexOf(true) <0)) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        const tl:TimelineLite = new TimelineLite({paused : true});
        this._wildOnReel.forEach((hasWild:boolean, index:number) => {
            if(hasWild) {
                this._view.nudgeWild(tl, index, this._wildOnReelPos[index], this._multiplierOnReel[index], this._gameAreaSize[index], this._winPositions[index].indexOf(true) < 0 || data.quickStop);
            }
        });
        tl.add(() => {
            this.reset();
            this.dispatchCompleteEvent(data.reelId);
        });
        this._timeline = tl;
        this._timeline.play(0);
    }

    public reset():void {
        super.reset();
        if(this._timeline){
            this._timeline!.kill();
        }
        this._view.resetMultipliers();
        this._timeline = null;
    }
}